import { render } from "./featured-carousel.vue?vue&type=template&id=5df94c61&scoped=true"
import script from "./featured-carousel.vue?vue&type=script&lang=js"
export * from "./featured-carousel.vue?vue&type=script&lang=js"

import "./featured-carousel.vue?vue&type=style&index=0&id=5df94c61&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df94c61"]])

export default __exports__